<template>
  <div class="panel-holder">
      <div class="close-holder">
        <a class="close" href="#" @click="close()"></a>
      </div>
    
      <div class="panel">
        <div>
          <ul>
            <li v-for="(slide, index) in slides" :key="slide.id" :class="{main: slide.type == 'home' || slide.type == 'subtitle', sub: slide.type != 'home' && slide.type != 'subtitle'}">
              <a href="#" @click.prevent="goToSlide(index)" v-if="slide.footnote" v-html="`${slide.footnote.artist}, ${slide.footnote.title}`"></a>
              <a href="#" @click.prevent="goToSlide(index)" v-else-if="slide.title" v-html="slide.title"></a>
              <a href="#" @click.prevent="goToSlide(index)" v-else-if="slide.subtitle" v-html="slide.subtitle"></a>
              <a href="#" @click.prevent="goToSlide(index)" v-else-if="slide.type == 'end'">
                <template v-if="alternateLanguage == 'en'">Kolofon</template>
                <template v-else>Credits</template>
              </a>
            </li>
          </ul>
        </div>
      </div>
  </div>
  
</template>

<script>
export default {
  name: 'navigation-panel',
  props: ['slides', 'alternateLanguage'],
  methods: {
    close() {
      this.$emit("closePanel", {});
    },
    goToSlide(index) {
      this.$root.$emit("goToSlide", index);
      this.close();
    }
  },
  created() {}
}
</script>

<style scoped>
.panel-holder {
  overflow: hidden;
}
.panel {
    color: #0c0c0c;
    text-align: left;
    padding: 60px;
    overscroll-behavior: contain;
}
.close-holder {
  height: 60px;
  width: 100%;
  background: #f2f2f2;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9999;
}
.close {
  top: 15px;
  left: calc(100% - 50px);
  width: 32px;
  height: 32px;
  color: #333;
  position: absolute;
  opacity: 1;
  transition: opacity 1s linear 1s;
}
.slideout-panel .slideout-wrapper .slideout.my-slide-panel.slideIn-enter-active .close {
  opacity: 0;
}
.slideout-panel .slideout-wrapper .slideout.my-slide-panel.slideIn-leave-active .close {
  opacity: 0;
  transition: opacity 200ms linear 0s;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
  transition: .3s all ease;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.close:hover:before, .close:hover:after {
  background-color: #cc0000;
}

ul {
  margin-top: 18px;
  list-style: none;
  padding-left: 0;
}
ul li {
  padding-bottom: 4px;
}
.slideout-panel .main {
  font-size: 20px;
  font-weight: 700;
  margin-top: 20px;
}
.main:first-of-type {
  margin-top: 0;
}
.slideout-panel .sub {
  list-style: disc;
  margin-left: 20px;
}
.slideout-panel .sub a {
  color: #0c0c0c !important;
}
.slideout-panel .main a:hover, .slideout-panel .main a:focus,
.slideout-panel .sub a:hover, .slideout-panel .sub a:focus {
  color: #cc0000 !important;
}

/* MEDIA QUERIES */
@media (max-width: 575px) {
  .panel {
    padding: 40px;
  }
}
@media (max-width: 400px) {
  .panel {
    padding: 40px 30px;
  }
}
</style>